import { useState } from "react";
import { EMAIL_REGEXP, MAX_EMAIL_LENGTH } from "../../../constants";
import { useAppDispatch } from "../../../redux";
import { setEmail } from "../ContactInfoSlice";

export const useEmail = (params: { error: boolean; setError(error: boolean): void; handleClose(): void }) => {
  const { error, setError, handleClose } = params;
  const [email, setEmailHook] = useState<string>("");
  const dispatch = useAppDispatch();

  const validateEmail = (email: string) => {
    if (email.length > MAX_EMAIL_LENGTH) return false;
    if (!EMAIL_REGEXP.test(email)) return false;
    return true;
  };

  const handleEmailChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    setError(false);

    if (value.length > MAX_EMAIL_LENGTH) return;

    if (EMAIL_REGEXP.test(value)) setError(false);
    else setError(true);

    setEmailHook(value);
  };

  const updateEmail = () => {
    if (!email || email === "") {
      handleClose();
      return dispatch(setEmail(""));
    }
    const validate = validateEmail(email);
    if (!validate) {
      setError(true);
      return;
    }
    handleClose();
    return dispatch(setEmail(email));
  };

  return {
    updateEmail,
    email,
    setEmailHook,
    error,
    setError,
    handleEmailChange,
  };
};
